<template>
  <b-modal
    ref="manageServerModal"
    centered
    size="lg"
    :title="serversModalTitle"
    hide-header-close
    scrollable
    footer-bg-variant=""
    body-class="pb-0"
    no-close-on-esc
    @hide="onHideAttempt"
    @hidden="unselectServer(), clearErrors()">
    <b-form @submit.stop.prevent>
      <b-form-group
        id="name-server"
        label="Name"
        label-for="name-input">
        <b-form-input
          id="name-input"
          name="name-input"
          v-model="selectedServer.name"
          :state="getValidationState('name')"
          aria-describedby="name-feedback"
          placeholder="US Server Dell R200" />
        <b-form-invalid-feedback
          v-for="(error, index) in manageServerError('name')"
          :key="`${error.field}-${index}`">
          {{ error.message }}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group
        id="country-server"
        label="Country"
        label-for="country-input">
        <b-form-select
          v-model="selectedServer.country"
          :state="getValidationState('country')"
          aria-describedby="country-feedback">
          <template #first>
            <b-form-select-option
              :value="null"
              disabled>
              Please select country
            </b-form-select-option>
          </template>
          <b-form-select-option
            v-for="country in countriesList"
            :key="`country-${country._id}`"
            :value="country.code">
            {{ country.name }}
          </b-form-select-option>
        </b-form-select>
        <b-form-invalid-feedback
          v-for="(error, index) in manageServerError('country')"
          :key="`${error.field}-${index}`">
          {{ error.message }}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group
        id="location-server"
        label="Location"
        label-for="location-input">
        <b-form-input
          id="location-input"
          name="location-input"
          v-model="selectedServer.location"
          :state="getValidationState('location')"
          aria-describedby="location-feedback"
          placeholder="New York" />
        <b-form-invalid-feedback
          v-for="(error, index) in manageServerError('location')"
          :key="`${error.field}-${index}`">
          {{ error.message }}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-row>
        <b-col cols="8">
          <b-form-group
            id="ip-server"
            :class="{ 'mb-2' : !selectedServerExist }">
            <template #label>
              <div class="d-flex align-items-center">
                <span>IP Address</span>
                <b-button
                  variant="link-info"
                  class="ml-auto font-weight-normal"
                  @click="$parent.showModal('openSshKey')">
                  SSH Connection (Instruction)
                </b-button>
              </div>
            </template>
            <b-form-input
              id="ip-input"
              name="ip-input"
              v-model="selectedServer.ip"
              :state="getValidationState('ip')"
              :disabled="selectedServerExist"
              :class="{ 'cursor-not-allowed' : selectedServerExist }"
              aria-describedby="ip-feedback"
              placeholder="xxx.xxx.xxx.xxx" />
            <b-form-invalid-feedback
              v-for="(error, index) in manageServerError('ip')"
              :key="`${error.field}-${index}`">
              {{ error.message }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-form-group
            id="ssh_port"
            label="SSH Port"
            label-for="ssh_port"
            :class="{ 'mb-2' : !selectedServerExist }">
            <b-form-input
              id="ssh_port"
              name="ssh_port"
              v-model.number="selectedServer.ssh_port"
              :state="getValidationState('ssh_port')"
              type="number"
              aria-describedby="ssh_port-feedback"
              min="1"
              max="65535"
              placeholder="22"
              @keydown="filterKey" />
            <b-form-invalid-feedback
              v-for="(error, index) in manageServerError('ssh_port')"
              :key="`${error.field}-${index}`">
              {{ error.message }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>

      <b-form-group v-if="!selectedServerExist">
        <b-form-checkbox
          id="check_connection-checkbox"
          v-model="selectedServer.check_connection"
          name="check_connection-checkbox">
          Check connections when adding
        </b-form-checkbox>
      </b-form-group>

      <b-row>
        <b-col
          col
          lg="6">
          <b-form-group
            id="latitude-server"
            label="Latitude"
            label-for="latitude-input">
            <b-form-input
              id="latitude-input"
              name="latitude-input"
              v-model.number="selectedServer.latitude"
              :state="getValidationState('latitude')"
              aria-describedby="latitude-feedback"
              placeholder="-33.873" />
            <b-form-invalid-feedback
              v-for="(error, index) in manageServerError('latitude')"
              :key="`${error.field}-${index}`">
              {{ error.message }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col
          col
          lg="6">
          <b-form-group
            id="longitude-server"
            label="Longitude"
            label-for="longitude-input">
            <b-form-input
              id="longitude-input"
              name="longitude-input"
              v-model.number="selectedServer.longitude"
              :state="getValidationState('longitude')"
              aria-describedby="longitude-feedback"
              placeholder="151.213" />
            <b-form-invalid-feedback
              v-for="(error, index) in manageServerError('longitude')"
              :key="`${error.field}-${index}`">
              {{ error.message }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>

      <b-form-group
        v-if="!recipesGroupsEmpty || !groupsEmpty"
        id="categories">
        <b-row>
          <b-col
            v-if="!recipesGroupsEmpty"
            col
            lg="6">
            <b-form-group
              id="recipes-group-server"
              label="Recipes Group (optional)">
              <b-form-radio-group
                id="recipes-group-radio"
                v-model="selectedServer.group_recipe"
                name="radio-options-group"
                stacked>
                <b-form-radio
                  v-for="recipeGroup in recipesGroupsList"
                  :key="`radio-${recipeGroup._id}`"
                  :value="recipeGroup._id"
                  size="md">
                  {{ recipeGroup.name }}
                </b-form-radio>
                <b-form-radio
                  :value="null"
                  size="md">
                  [ None of above ]
                </b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
          <b-col
            v-if="!groupsEmpty"
            col
            lg="6">
            <b-form-group
              id="group-server"
              label="Groups (optional)"
              class="mb-0">
              <b-form-checkbox-group
                id="groups-checkbox-group"
                v-model="selectedServer.group"
                name="checkbox-options"
                stacked>
                <b-form-checkbox
                  v-for="group in groupsList"
                  :key="`checkox-${group._id}`"
                  :value="group._id"
                  size="md">
                  {{ group.name }}
                </b-form-checkbox>
              </b-form-checkbox-group>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form-group>

      <b-form-group v-if="!selectedServerExist">
        <b-form-checkbox
          id="visibility-checkbox"
          v-model="selectedServer.visibility"
          name="visibility-checkbox">
          Make server visible for user and resellers
        </b-form-checkbox>
      </b-form-group>
    </b-form>

    <template #modal-footer>
      <div class="d-flex w-100">
        <b-button
          v-b-tooltip.hover.right
          id="cancelModal"
          title="Are you sure? Unsaved data will be lost."
          variant="outline-secondary"
          size="md"
          @click="hideModal('manageServerModal')">
          Cancel
        </b-button>
        <b-button
          variant="primary"
          v-wave
          size="md"
          class="ml-auto"
          :disabled="serversResponses('manageServer')"
          @click="submitServer()">
          Submit
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {
  // actions
  GET_SERVER,
  GET_SERVERS,
  MANAGE_SERVER,

  // mutations
  UNSELECT_SERVER,
  CLEAR_MANAGE_SERVER_ERRORS,
} from '@/core/services/store/servers.module'
import { mapGetters } from 'vuex'
import { eventBus } from '@/main'
import {
  showModal,
  hideModal,
  onHideAttempt,
  filterKey
} from '@/core/utils'

export default {
  name: 'ModalManageServer',
  data() {
    return {
      showModal,
      hideModal,
      onHideAttempt,
      filterKey,
    }
  },
  computed: {
    ...mapGetters([
      'countriesList',

      'groupsList',
      'groupsEmpty',

      'recipesGroupsList',
      'recipesGroupsEmpty',

      'selectedServer',
      'selectedServerId',
      'selectedServerExist',
      'serversModalTitle',
      'manageServerErrors',
      'manageServerError',
      'serversResponses',
    ]),
  },
  mounted() {
    eventBus.$on('openModal', type => { this.showModal(type) })
  },
  destroyed() {
    eventBus.$off('openModal')
  },
  methods: {
    submitServer() {
      this.$store.dispatch(MANAGE_SERVER)
        .then(() => {
          if (this.selectedServerId) {
            this.$store.dispatch(GET_SERVER, { id: this.selectedServerId })
          } else {
            this.$store.dispatch(GET_SERVERS)
          }
        })
        .then(() => {
          this.hideModal('manageServerModal')
        })
    },

    clearErrors() {
      this.$store.commit(CLEAR_MANAGE_SERVER_ERRORS)
    },

    unselectServer() {
      this.$store.commit(UNSELECT_SERVER)
    },

    getValidationState(field) {
      return this.manageServerErrors.some(err => err.field == field) ? false : null
    },
  },
}
</script>
